import {createAction, props} from '@ngrx/store';
import {User} from '../models/user.model';
import {UserPermissions} from '../models/user-permissions.model';
import {Timestamp} from '@firebase/firestore';
import {SupportedLanguage} from '../models/supported-language.model';


export const login = createAction(
  '[Firebase Auth] Login',
  props<User>()
);

export const setUserPermissions = createAction(
  '[Firebase Auth] Set User Permissions',
  props<UserPermissions>()
);

export const logout = createAction(
  '[Top Menu] Logout'
);


export const userLoaded = createAction(
  '[App Startup] User Loaded',
  props<{ user: Partial<User> }>()
);

export const planActivated = createAction(
  '[Subscriptions Page] Plan Activated',
  props<{ selectedPlan: string, user: Partial<User> }>()
);

export const planCancelled = createAction(
  '[My Account Screen] Plan Cancelled',
  props<{ planEndsAt: Timestamp }>()
);

export const cardUpdated = createAction(
  '[My Account Screen] Credit Card Updated',
  props<{ user: Partial<User> }>()
);

export const subscriberInfoMessageShown = createAction(
  '[Courses Screen] Subscriber Info Message Shown'
);

export const updateNewsletterStatus = createAction(
  '[My Account Screen] Update Newsletter status',
  props<{ unsubscribeFromNewsletter: boolean }>()
);

export const updateUserLanguage = createAction(
  "[My Account Screen] Update User Language",
  props<{language:SupportedLanguage}>()
);

export const userDetailsUpdated = createAction(
  "[Update User Details] Update User Details",
  props<{userId:string, changes: Partial<User>}>()
);

